export default __webpack_public_path__ + "static/media/tag.f19dff87.svg";